import L from 'leaflet';

export function initIntroPanel(map: L.Map) {
    // 1. Get References (Element is now in index.html)
    const panel = document.getElementById('intro-panel');
    const closeBtn = document.getElementById('close-intro-btn');

    if (!panel || !closeBtn) {
        console.error('Intro panel elements not found in DOM');
        return;
    }

    // 2. Attach Listeners
    map.getContainer().addEventListener('open-intro-panel', () => {
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
        } else {
            map.getContainer().dispatchEvent(new CustomEvent('close-other-panels', { detail: 'intro-panel' }));
            panel.style.display = 'block';
        }
    });

    map.getContainer().addEventListener('close-other-panels', (e: any) => {
        if (e.detail !== 'intro-panel') {
            panel.style.display = 'none';
        }
    });

    closeBtn.addEventListener('click', () => {
        panel.style.display = 'none';
    });
}
